var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon3D(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.584,
    height: 9.8,
    viewBox: "0 0 24.584 9.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-353.579 41.534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.5-34.844c0,1.624-1.621,3.11-5.165,3.11a10.484,10.484,0,0,1-4.756-1.033l1.121-1.707a7.326,7.326,0,0,0,3.564.868c1.441,0,2.333-.453,2.333-1.238,0-.73-.694-1.183-2.333-1.183h-1.319V-37.5l2.564-2.244H354.2v-1.789h8.727v1.446l-2.813,2.477C362.36-37.336,363.5-36.262,363.5-34.844Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.074-41.534h5.665c4.079,0,6.875,1.9,6.875,4.818s-2.8,4.817-6.875,4.817h-5.665Zm5.523,7.805c2.476,0,4.1-1.143,4.1-2.987s-1.62-2.986-4.1-2.986H366.96v5.974Z",
    transform: "translate(1.55 0)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3D);
export default __webpack_public_path__ + "static/media/icon_3d.e6e0d2b8da820a40c44f14d20730aa58.svg";
export { ForwardRef as ReactComponent };